<template>
  <div>
    <b-skeleton-table v-if="fetchData" :rows="3" :columns="2" :table-props="{ bordered: true, striped: true }" />
    <b-container class="m-1" v-else>
      <!-- Reports -->
      <b-row>
        <h4>
          All reports are listed below. Select the reports to add them to course
          file
        </h4>
      </b-row>
      <br />
      <b-row>
        <b-col v-if="reportOptions.length < 1" class="text-info">
          All reports are selected
        </b-col>

        <!-- Select All -->
        <b-col @click="selectAllReports()" v-if="reportOptions.length > 1" sm="4" md="3" lg="2"
          class="glow-button btn border-warning p-1 m-1 shadow cursor-move rounded-lg">
          Select all reports
        </b-col>

        <!-- Unselect All -->
        <b-col @click="unselectAllReports()" v-if="selectedReports.length > 0" sm="4" md="3" lg="2"
          class="glow-button btn border-danger p-1 m-1 shadow cursor-move rounded-lg">
          Unselect all reports
        </b-col>

        <!-- Individual Reports -->
        <b-col sm="4" md="3" lg="2"
          v-b-popover.hover.top="report.config === false ? 'This file has not been configured. Complete configuration and try downloading again.' : ''"
          :class="{
            'glow-button btn  p-1 m-1 shadow cursor-move rounded-lg': true,
            'border-danger': report.config === false,
          }" v-for="(report, index) in reportOptions" :key="index" @click="selectReport(index)">
          {{ report.name }}
        </b-col>
      </b-row>

      <br />
      <b-row>
        <h4>
          Selected reports are listed below. Grab and move to reorder the
          reports as required in course file. The index page will display list
          of reports in the same order
        </h4>
      </b-row>
      <br />
      <b-container>
        <b-col v-if="selectedReports.length < 1" sm="8" md="8" lg="8" class="text-danger shadow rounded-lg">
          Please choose reports from above
        </b-col>

        <!-- Draggable selected reports -->
        <draggable :list="selectedReports">
          <b-col style="cursor: grab;" sm="8" md="8" lg="8"
            class="shadow cursor-move rounded-lg p-2 my-2 d-flex align-items-center justify-content-between"
            v-for="(report, index) in selectedReports" :key="index">
            <div class="d-flex align-items-center">

              <!-- <b-form-checkbox
                v-if="allowAddRemove"
                v-model="report.selected"
                class="mr-2"
              ></b-form-checkbox> -->

              <i class="fas fa-bars mr-2" aria-hidden="true"></i>
              <span class="mr-1">{{ index + 1 }}</span>
              {{ report.name }}
            </div>

            <i role="button" @click="deSelectReport(index)" class="text-danger fa fa-times-circle-o"
              aria-hidden="true"></i>
          </b-col>
        </draggable>
      </b-container>

      <br /><br /><br /><br />
      <!-- selectedReports {{ selectedReports }} -->
      <!-- Radio Options -->
      <b-row>
        <b-col sm="12">
          <h5>Course File Order Settings</h5>

          <b-form-group>
            <!-- Option 1 -->
            <b-form-radio v-model="courseFileOrderOption" :value="1">
              Don’t lock or set default order currently
            </b-form-radio>

            <!-- Option 2 -->
            <b-form-radio v-model="courseFileOrderOption" :value="2">
              Set the above course file default order for all the courses under
              this programme
            </b-form-radio>

            <!-- Option 3 -->
            <b-form-radio v-model="courseFileOrderOption" :value="3">
              Lock the course file order as above for all courses under this
              programme
            </b-form-radio>

            <!-- Sub Checkbox -->
            <b-form-checkbox v-if="courseFileOrderOption === 3" v-model="allowAddRemove">
              Allow user to add or remove selected files
            </b-form-checkbox>
          </b-form-group>

          <!-- Warning message -->
          <p class="text-danger mt-2" v-if="courseFileOrderOption === 3">
            Choosing this setting will replace already saved course file order
            for all the courses under this programme.
          </p>
        </b-col>
      </b-row>
    
      <div class="row" v-if="allowAddRemove && courseFileOrderOption === 3">
        <div
          class="col-sm-6 col-md-4 col-lg-3"
          v-for="(report, index) in selectedReports"
          :key="index"
        >
          <b-form-checkbox v-model="report.selected" inline class="mr-2">
            {{ index + 1 }}. {{ report.name }}
          </b-form-checkbox>
        </div>
      </div>

      <!-- Action buttons -->
      <div class="text-right mt-2">
        <b-button size="sm" variant="primary" class="mr-2" @click="setCourseFileOrder">
          Update
        </b-button>
        <b-button size="sm" variant="secondary" @click="cancelCourseFileOrder">
          Cancel
        </b-button>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["usergroup_id"],
  async created() {
    await this.getCourseFileSettings();
  },
  data() {
    return {
      fetchData: false,
      courseFileOrderOption: 1,
      allowAddRemove: false,
      reportOptions: [
        { key: "course_diary_index", name: "Course Diary Index page", config: null, enable: true, order: 0 },
        { key: "courseFaculty_schedules", name: "Instructor Schedule", config: null, enable: true, order: 0 },
        { key: "courseModules", name: "Course Syllabus", config: null, enable: true, order: 0 },
        { key: "courseOutcomes", name: "Course Outcome(CO)", config: null, enable: true, order: 0 },
        { key: "courseProgrammeoutcomes", name: "Program Outcome(PO)", config: null, enable: true, order: 0 },
        { key: "subgroupProgrammespecificoutcomes", name: "Program Specific Outcome(PSO)", config: null, enable: true, order: 0 },
        { key: "coPoPsoMapping", name: "CO/PO/PSO Mapping", config: null, enable: true, order: 0 },
        { key: "courseLessonplans", name: "Lesson Plan", config: null, enable: true, order: 0 },
        { key: "courseStudents", name: "Student Roll List", config: null, enable: true, order: 0 },
        { key: "activity_detailes", name: "Details Of Assignment", config: null, enable: true, order: 0 },
        { key: "DetailesOfCourseTutorials", name: "Details Of Tutorials", config: null, enable: true, order: 0 },
        { key: "tutorialLogRegister", name: "Tutorial List Log Register", config: null, enable: true, order: 0 },
        { key: "courseOutcomesVsAssessmentTools", name: "Assessment Instruments & COs", config: null, enable: true, order: 0 },
        { key: "courseProperty_details_of_lerning_matials", name: "Details Of Learning Material Provide", config: null, enable: true, order: 0 },
        { key: "courseProperty_content_beyond_syllabus", name: "Content Beyond The Syllabus", config: null, enable: true, order: 0 },
        { key: "courseProperty_industrial_relevence", name: "Industrial Relevance Of Course", config: null, enable: true, order: 0 },
        { key: "courseClassTypeDetailes_extra_class", name: "Details Of Extra Class", config: null, enable: true, order: 0 },
        { key: "courseClassTypeDetailes_remedial_class", name: "Details Of Remedial Class", config: null, enable: true, order: 0 },
        { key: "courseClassTypeDetailes_revision", name: "Details Of Revision Class", config: null, enable: true, order: 0 },
        { key: "courseClassTypeDetailes_bridge_class", name: "Remedial/ Bridge Class Log Register", config: null, enable: true, order: 0 },
        { key: "courseStudentsVsAttendanceType_count", name: "Attendance Summary Reports", config: null, enable: true, order: 0 },
        { key: "courseStudentsVsAttendanceDate", name: "Attendance Detailed Reports", config: null, enable: true, order: 0 },
        { key: "course_lab_experiments", name: "Lab Experiments", config: null, enable: true, order: 0 },
        { key: "lab_evaluation_sheet", name: "Lab Evaluation Sheet", config: null, enable: true, order: 0 },
        { key: "courseDeliveryHistory", name: "Course Coverage Report", config: null, enable: true, order: 0 },
        { key: "courseContinuoesEvaluation", name: "Internal Evaluation Report", config: null, enable: true, order: 0 },
        { key: "courseAttainmentSummary", name: "Attainment Reports", config: null, enable: true, order: 0 },
        { key: "faculties_detailedFeedback", name: "Feedback Survey Reports", config: null, enable: true, order: 0 },
        { key: "project_evaluationSheet", name: "Project Evaluation Reports", config: null, enable: true, order: 0 },
        { key: "seminar_evaluationSheet", name: "Seminar Evaluation Reports", config: null, enable: true, order: 0 },
        { key: "programme_vision_and_mission", name: "Programme Vision & Mission", config: null, enable: true, order: 0 },
        { key: "institution_vision_and_mission", name: "Institution Vision & Mission", config: null, enable: true, order: 0 },
      ],
      selectedReports: [],
    };
  },
  methods: {
    unselectAllReports() {
      for (let i = this.selectedReports.length - 1; i >= 0; i--) {
        this.reportOptions.push(this.selectedReports[i]);
        this.selectedReports.splice(i, 1);
      }
    },
    selectReport(index) {
      if (this.reportOptions[index].config === false) {
        this.$toast.error(
          "This file has not been configured. Complete configuration and try downloading again.",
          { position: "top", duration: 6000 }
        );
        return;
      }
      this.selectedReports.push({
        ...this.reportOptions[index],
        selected: true,
      });
      this.reportOptions.splice(index, 1);
    },
    deSelectReport(index) {
      this.reportOptions.push(this.selectedReports[index]);
      this.selectedReports.splice(index, 1);
    },
    async selectAllReports() {
      for (let i = this.reportOptions.length - 1; i >= 0; i--) {
        if (this.reportOptions[i].config != false) {
          this.selectedReports.push({
            ...this.reportOptions[i],
            selected: true,
          });
          this.reportOptions.splice(i, 1);
        }
      }
    },
    async setCourseFileOrder() {
      const baseUrl =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups/setting/${this.usergroup_id}`;

      const requests = [
        this.$axios.post(`${baseUrl}/course_file_order`, {
          // Only keep selected if allowAddRemove
          course_file_order: this.selectedReports,
        }),
        this.$axios.post(`${baseUrl}/course_file_order_option`, {
          course_file_order_option: this.courseFileOrderOption,
        }),
        this.$axios.post(`${baseUrl}/course_file_allow_add_remove`, {
          course_file_allow_add_remove: this.allowAddRemove,
        }),
      ];

      try {
        await Promise.all(requests);
        this.$toast.success("Course File Settings Updated", { position: "top" });
      } catch (error) {
        this.$toast.error("Update failed", { position: "top" });
      }
    },
    async getCourseFileSettings() {
      const baseUrl =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups/setting/${this.usergroup_id}`;

      try {
        // ✅ Fetch all settings in parallel
        const [orderRes, optionRes, allowRes] = await Promise.all([
          this.$axios.get(`${baseUrl}/course_file_order`),
          this.$axios.get(`${baseUrl}/course_file_order_option`),
          this.$axios.get(`${baseUrl}/course_file_allow_add_remove`),
        ]);

        // Reports
        let savedReports = Array.isArray(orderRes.data)
          ? orderRes.data
          : (orderRes.data.course_file_order || []);

        this.selectedReports = savedReports.map((r) => ({
          ...r,
          selected: r.selected !== undefined ? r.selected : true, // default checked
        }));

        // Filter reportOptions
        const selectedKeys = this.selectedReports.map((r) => r.key);
        this.reportOptions = this.reportOptions.filter(
          (r) => !selectedKeys.includes(r.key)
        );

        // Options
        this.courseFileOrderOption = optionRes.data;
        if (allowRes.data && allowRes.data == 1) {
          this.allowAddRemove = true;
        }

      } catch (error) {
        console.error("Failed to fetch course file settings", error);
      }
    },
  },
};
</script>

<style>
.glow-button {
  transition: all 0.2s ease-in-out;
}

.glow-button:hover {
  box-shadow: 0 5px 15px rgba(145, 92, 182, 0.4) !important;
}
</style>
